import { useState } from "react";
import { useSelector } from "react-redux";

const TableHead = ({columns, requestSort, getClassName}) => {


    return (
        <thead>
            <tr>
                {columns.map((item, i) => {
                    return (
                        <td key={i}>
                            {item.value == 'actions' || item.value == 'action' ? item.label : <span className={getClassName(item.value)} onClick={() => requestSort(item.value)}>{item.label}</span>}
                        </td>
                    )
                })}
            </tr>
        </thead>
    )
}

export default TableHead